var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeaderComponent'),_c('router-view',{attrs:{"isEmpty":_vm.isEmpty,"isLogin":this.isLogin,"cartType":this.getUrlCartType}}),_c('scrollTopBtn'),_c('FooterComponent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }